import { createContext, useContext, useRef, useEffect } from 'react';

export enum HeaderVisibility {
  show = 'show',
  hide = 'hide',
  auto = 'auto',
}
export interface MainPageContextType {
  footer: boolean;
  toolbar: boolean;
  header: HeaderVisibility;
  setConfig?: React.Dispatch<React.SetStateAction<MainPageContextType>>;
}
export const MainPageContext = createContext<MainPageContextType>({ footer: true, toolbar: true, header: HeaderVisibility.show });

export function useMainPageContext() {
  return useContext(MainPageContext);
}

export function useMainPageConfig(fn: () => Partial<MainPageContextType>) {
  const oldConfig = useMainPageContext();
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (fnRef.current) {
      const config = fnRef.current();
      oldConfig.setConfig && oldConfig.setConfig({ ...oldConfig, ...config });

      return () => oldConfig.setConfig && oldConfig.setConfig({ ...oldConfig, footer: true, toolbar: true, header: HeaderVisibility.show });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
